import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { DSSetup, RecordAttributes, RecordData } from 'webapp-types';
import { omit } from 'webapp/utils/common';

import ApplicationSerializer from 'webapp/serializers/application';

import type ClientMetricRecord from 'webapp/models/client-metric';

export default class ClientMetricSerializer extends ApplicationSerializer {
	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a record through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.ClientMetric.Raw | RecordData.ClientMetric.Serialized,
		prop: string | undefined,
	) {
		const { metricSetup, ...data } = json;
		const attributes: Partial<RecordAttributes<ClientMetricRecord>> & { id?: string | number } =
			{
				...data,
			};

		if (metricSetup) {
			const normalizedMetricSetup = this.normalizeMetricSetupData(
				metricSetup as DSSetup.MetricSetupData,
			)!;
			attributes.metricSetupKey = normalizedMetricSetup.key;
			attributes.metricSetupSpaceAccessId = normalizedMetricSetup.spaceAccessId;
			attributes.metricSetupDimensions = normalizedMetricSetup.dimensions || [];
			attributes.metricSetupFilters = normalizedMetricSetup.filters || null;
		}

		return super.normalize(typeClass, attributes, prop);
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.ClientMetric.Serialized {
		const attributes = super.serialize(
			snapshot,
			options,
		) as RecordAttributes<ClientMetricRecord>;

		return {
			...omit(
				attributes,
				'metricSetupKey',
				'metricSetupSpaceAccessId',
				'metricSetupDimensions',
				'metricSetupFilters',
			),
			// key is null when no metric is set
			metricSetup: this.serializeMetricSetupData({
				key: attributes.metricSetupKey,
				spaceAccessId: attributes.metricSetupSpaceAccessId,
				dimensions: attributes.metricSetupDimensions,
				filters: attributes.metricSetupFilters,
			}),
		};
	}
}
